import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { concat, EMPTY, from, Observable, of } from 'rxjs';
import { LoadDataRequest, LoadDataRequestAtlas } from '../../global/interfaces';
import * as documents from './documents.actions';

import { HttpService } from '../../global/http.service';
import { downloadFile } from '../../global/fileDownload';
import { LoadDocumentsResponse } from './documents.models';
import { createPostQuery } from '../../shared/utils';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';


@Injectable()
export class DocumentsEffects {
  public loadDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<documents.LoadDocumentsAction>(documents.ActionTypes.LOAD_DOCUMENTS),
    map(action => action.payload),
    switchMap(payload =>
      this.loadDocuments(payload).pipe(
        map((response: LoadDocumentsResponse) =>
          new documents.LoadDocumentsSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new documents.LoadDocumentsFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new documents.LoadDocumentsFailedAction(error));
          // }
          concat(
            of(new documents.LoadDocumentsFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public loadMobileDocuments$ = createEffect(() => this.actions$.pipe(
    ofType<documents.LoadMobileDocumentsAction>(documents.ActionTypes.LOAD_MOBILE_DOCUMENTS),
    map(action => action.payload),
    switchMap(payload =>
      this.loadDocuments(payload).pipe(
        map((response: LoadDocumentsResponse) =>
          new documents.LoadMobileDocumentsSuccessAction(response)
        ),
        catchError(error =>
          // (from([
          //   new documents.LoadMobileDocumentsFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ]))
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new documents.LoadMobileDocumentsFailedAction(error));
          // }
          concat(
            of(new documents.LoadMobileDocumentsFailedAction(error)),
            of(null).pipe(
              tap(() => {
                this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
              })
            )
          )
        )
      )
    )));

  public fileDownload$ = createEffect(() => this.actions$.pipe(
    ofType<documents.DocumentsFileDownloadAction>(documents.ActionTypes.DOCUMENTS_FILE_DOWNLOAD),
    map(action => action.payload),
    switchMap(payload =>
      this.downloadDocumentsFile(payload.id).pipe(
        map((response: any) => {
          // deepcode ignore DOMXSS:internally created secure response
          downloadFile(response.body, '*/*', `${payload.originalName}`);
        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ]
          // )

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ), { dispatch: false });

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadDocuments(payload: LoadDataRequestAtlas): Observable<LoadDocumentsResponse> {
    const sortColumnName = payload != null && payload.sort != null ?
      (payload.sort.column === 'title' ? 'filename' : payload.sort.column) : '';
    payload = {
      ...payload,
      sort: { ...payload.sort, column: sortColumnName }
    };
    return this.http.post(`/library`, createPostQuery(payload), { withCredentials: true });
  }

  private downloadDocumentsFile(id: string): Observable<any> {
    return this.http.get(`/documents/${id}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
